//@ts-strict-ignore
import React, { useMemo } from 'react';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import Workspace from '../../components/Workspace';
import { CostViewPermission, Direction, FilterOperation } from '../../graphql/schema/p4types';
import { useSelector } from 'react-redux';
import { IEditableDataGridColumnDef } from '../../@types/editableDataGridTypes';
import { Maybe } from 'graphql/jsutils/Maybe';

export const RefNameCell = ({ dependentValues }) => {
  if (!dependentValues.rowData || !dependentValues.rowData.node) return <div />;
  const { reference, name } = dependentValues.rowData.node;
  return (
    <div>
      <div className="cell-primary">{reference}</div>
      <div className="cell-data">{name}</div>
    </div>
  );
};

const availableColumnsFilter = (column: IEditableDataGridColumnDef): boolean => {
  const fieldName: Maybe<string> = column?.fieldName;

  if (!fieldName) {
    return false;
  }

  return !(fieldName.includes('createdBy') || fieldName.includes('createdAt'));
};

const config = {
  fieldNames: ['updatedAt', 'updatedBy', 'fieldName', 'oldValue', 'newValue'],
  columnOverrides: {
    updatedAt: {
      name: 'Updated At',
      fieldName: 'updatedAt',
      type: 'LocalDateTime',
    },
    updatedBy: {
      name: 'Updated By',
      fieldName: 'updatedBy',
      type: 'String',
    },
    fieldName: {
      name: 'Field Name',
      fieldName: 'fieldName',
      type: 'String',
    },
    oldValue: {
      name: 'Old Value',
      fieldName: 'oldValue',
      type: 'String',
    },
    newValue: {
      name: 'New Value',
      fieldName: 'newValue',
      type: 'String',
    },
  },
};

const AuditByFieldWorkspace = (props) => {
  const costViewPermission = useSelector((store) => store.app?.fullUserDetails?.companyUser?.costViewPermission);
  const filters = useMemo(() => {
    const filtersList = [...(props.predefinedFilters ?? [])];
    if (costViewPermission === CostViewPermission.None || costViewPermission === CostViewPermission.Haggle) {
      filtersList.push({
        filterOperation: FilterOperation.NotIn,
        filterParameters: {
          field: 'fieldName',
          value:
            'Valuation Cost Price,Real Valuation Cost Price,Latest Cost Price,Real Latest Cost Price,Cost Price 1,' +
            'Cost Price 2,Cost Price Break 2,Cost Price 3,Cost Price Break 3,Cost Price 4,Cost Price Break 4,Profit Value,' +
            'Profit Margin,Cost Total,Base Cost Total,Base Profit Value',
        },
      });
    }
    if (costViewPermission === CostViewPermission.None) {
      filtersList.push({
        filterOperation: FilterOperation.NotIn,
        filterParameters: {
          field: 'fieldName',
          value:
            'Haggle Cost Price,Cost Unit Quantity,Cost Unit Description,Haggle Cost Total,Base Haggle Cost Total,' +
            'Base Haggle Profit Value,Haggle Profit Value,Haggle Profit Margin',
        },
      });
    }
    return filtersList;
  }, [costViewPermission, props.predefinedFilters]);

  const workspaceProps = useWorkspace(props, props.entity, {
    columns: config.fieldNames || [],
    columnOverrides: config.columnOverrides,
    initialSortColumn: 'updatedAt',
    initialSortDirection: Direction.Desc,
    filters: filters,
  });

  return (
    <Workspace
      entityType={props.entity.type}
      title={props.entity.title}
      cellRenderer={RefNameCell}
      defaultQuery={props.entity.workspace}
      genericFilter={false}
      slowWorkspace={true}
      availableColumnsFilter={availableColumnsFilter}
      availableFiltersFilter={availableColumnsFilter}
      testId="audit-by-field-workspace"
      {...workspaceProps}
      {...props}
    />
  );
};

export default AuditByFieldWorkspace;
